export default "__VITE_ASSET__7i_hVesd__"